import { API_PDC_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const operationsConstants = {
  CREATE_RECONCILIATION_LINK_START: "CREATE_RECONCILIATION_LINK_START",
  CREATE_RECONCILIATION_LINK_SUCCESS: "CREATE_RECONCILIATION_LINK_SUCCESS",
  CREATE_RECONCILIATION_LINK_ERROR: "CREATE_RECONCILIATION_LINK_ERROR",

  REMOVE_RECONCILIATION_LINK_START: "REMOVE_RECONCILIATION_LINK_START",
  REMOVE_RECONCILIATION_LINK_SUCCESS: "REMOVE_RECONCILIATION_LINK_SUCCESS",
  REMOVE_RECONCILIATION_LINK_ERROR: "REMOVE_RECONCILIATION_LINK_ERROR",

  GET_RECONCILABLE_DEADLINES_START: "GET_RECONCILABLE_DEADLINES_START",
  GET_RECONCILABLE_DEADLINES_SUCCESS: "GET_RECONCILABLE_DEADLINES_SUCCESS",
  GET_RECONCILABLE_DEADLINES_ERROR: "GET_RECONCILABLE_DEADLINES_ERROR",

  GET_RECONCILED_SUMMARY_START: "GET_RECONCILED_SUMMARY_START",
  GET_RECONCILED_SUMMARY_SUCCESS: "GET_RECONCILED_SUMMARY_SUCCESS",
  GET_RECONCILED_SUMMARY_ERROR: "GET_RECONCILED_SUMMARY_ERROR",

  POST_RECONCILED_TO_REGISTER_START: "POST_RECONCILED_TO_REGISTER_START",
  POST_RECONCILED_TO_REGISTER_SUCCESS: "POST_RECONCILED_TO_REGISTER_SUCCESS",
  POST_RECONCILED_TO_REGISTER_ERROR: "POST_RECONCILED_TO_REGISTER_ERROR"
};

export function createReconciliationLink(
  auth,
  accountantUuid,
  companyUuid,
  links,
  source
  // operation
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: operationsConstants.CREATE_RECONCILIATION_LINK_START
      });

      let request = {
        method: "POST",
        url: API_PDC_URL_V1 + "/reconciliation/create",
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: {
          links: links,
          source: source,
          // operation: operation,
          managerId: accountantUuid,
          itemId: companyUuid
        }
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: operationsConstants.CREATE_RECONCILIATION_LINK_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: operationsConstants.CREATE_RECONCILIATION_LINK_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: operationsConstants.CREATE_RECONCILIATION_LINK_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function removeReconciliationLink(
  auth,
  accountantUuid,
  companyUuid,
  links,
  source
  // operation
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: operationsConstants.REMOVE_RECONCILIATION_LINK_START
      });

      let request = {
        method: "DELETE",
        url: API_PDC_URL_V1 + "/reconciliation/delete",
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: {
          links: links,
          source: source,
          // operation: operation,
          managerId: accountantUuid,
          itemId: companyUuid
        }
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: operationsConstants.REMOVE_RECONCILIATION_LINK_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: operationsConstants.REMOVE_RECONCILIATION_LINK_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: operationsConstants.REMOVE_RECONCILIATION_LINK_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function getReconcilableDeadlines(
  transactionId, fromDate, toDate, counterparts, documentDate, documentNumbers, documentAmounts
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      dispatch({
        type: operationsConstants.GET_RECONCILABLE_DEADLINES_START
      });
      const urlRequest = `${API_PDC_URL_V1}/reconciliation/genius/${transactionId}?managerId=${managerId}&itemId=${itemId}&fromDate=${fromDate}&toDate=${toDate}&paymentStep=to_be_paid, to_be_collected${
        counterparts ? "&counterpartDescription=" + counterparts : ""
      }${documentDate ? "&documentDate=" + documentDate : ""}${documentNumbers ? "&documentNumber=" + documentNumbers : ""}${
        documentAmounts ? "&amount=" + documentAmounts : ""
      }`;

      let request = {
        method: "GET",
        url: urlRequest,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: operationsConstants.GET_RECONCILABLE_DEADLINES_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: operationsConstants.GET_RECONCILABLE_DEADLINES_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: operationsConstants.GET_RECONCILABLE_DEADLINES_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function getReconciledSummary() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      dispatch({
        type: operationsConstants.GET_RECONCILED_SUMMARY_START
      });

      let request = {
        method: "GET",
        url: `${API_PDC_URL_V1}/reconciliation/conciliated-summary?managerId=${managerId}&itemId=${itemId}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: operationsConstants.GET_RECONCILED_SUMMARY_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: operationsConstants.GET_RECONCILED_SUMMARY_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: operationsConstants.GET_RECONCILED_SUMMARY_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function postReconciledToRegister(
  auth, requestBodyList, itemUuid, managerUuid
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: operationsConstants.POST_RECONCILED_TO_REGISTER_START
      });

      let request = {
        method: "POST",
        url: `${API_PDC_URL_V1}/reconciliation/create/accounting`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: {
          reconciliationSummaryApiReq: requestBodyList,
          itemId: itemUuid,
          managerId: managerUuid
        }
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: operationsConstants.POST_RECONCILED_TO_REGISTER_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: operationsConstants.POST_RECONCILED_TO_REGISTER_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: operationsConstants.POST_RECONCILED_TO_REGISTER_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}
